import { format, parse } from "date-fns";
import { SetStateAction, useEffect } from "react";

export interface TileApiResponse {
  // Optional fallback/error tile (Leaflet errorTileUrl); the API emits it as
  // `nulltile` and it may be absent — rendering does not require it.
  nullTile?: string;
  // Per-zoom tile extents from the manifest; not currently consumed by WrfLayer.
  zooms?: Record<string, number[][]>;
  baseURL: string;
  times: Date[];
}

const apiTimeFormat = "yyyyMMdd'_'HHmmss";

export const fromApiTimeFormat = (time: string) =>
  parse(time, apiTimeFormat, new Date());

export const toApiTimeFormat = (time: Date) => format(time, apiTimeFormat);

// Argument order matches RadarContext's private useLoopFrames so the two stay
// consistent (and can be unified later): (speed, frame, reset, frameCount, setFrame).
export const useLoopFrames = (
  speed: number,
  frame: number,
  reset: boolean,
  frameCount: number,
  setFrame: (number: SetStateAction<number>) => void
) => {
  useEffect(() => {
    if (reset || frameCount <= 0) {
      setFrame(0);
      return;
    }

    if (speed <= 0) {
      return;
    }

    const updateFrame = () =>
      setFrame((frame) => (frame === 0 ? frameCount - 1 : frame - 1));

    const delta = (1000 - speed) * (frame === 0 ? 4 : 1);
    const interval = setInterval(updateFrame, delta);
    return () => clearInterval(interval);
  }, [frame, frameCount, reset, setFrame, speed]);
};
